export const componentValidation = {
  methods: {
    $_componentValidation_isFormValid() {
      return !this.$helper.isValidationFailed(this)
    }
  }
}
